/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Modal from 'flarum/common/components/Modal';
import AchievementLevelSelector from '../../../common/components/AchievementLevelSelector';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.user.assign_achievement`;

export default class AssignAchievementLevelModal extends Modal {
	oninit(vnode) {
		super.oninit(vnode);
		this.loading = false;
		this.achievementLevelId = new Stream();

		if (this.attrs.user.userAchievements() === false) {
			this.loading = true;

			// load users with userAchievements
			app.store
				.find('users', this.attrs.user.id(), {
					include: 'userAchievements,userAchievements.achievement,userAchievements.achievementLevel',
				})
				.then((user) => {
					this.attrs.user = user;
					this.loading = false;
					m.redraw();
				});
		}
	}

	className() {
		return 'Modal--small AssignAchievementLevelModal';
	}

	title() {
		return t(`${prfx}.title`, { displayName: this.attrs.user.displayName() });
	}

	content() {
		return [
			<div className="Modal-body">
				<AchievementLevelSelector value={this.achievementLevelId()} onchange={(id) => this.achievementLevelId(id)} user={this.attrs.user} />

				<div className="Form-group">
					<Button className="Button Button--primary AssignAchievementLevelModal-save" type="submit" loading={this.loading}>
						{t(`${prfx}.submit_label`)}
					</Button>
				</div>
			</div>,
		];
	}

	async onsubmit(e) {
		e.preventDefault();

		this.loading = true;
		m.redraw();

		const achievementLevel = app.store.getById('achievement_levels', this.achievementLevelId());

		const userAchievement = app.store.createRecord('user_achievements');

		// Set user, achievement and achievement level relationships
		await userAchievement.save({
			relationships: {
				user: this.attrs.user,
				achievement: achievementLevel.achievement(),
				achievementLevel: achievementLevel,
			},
		});

		this.loading = false;
		m.redraw();
		this.hide();
	}
}
